import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IDataPanelViewModel, IStatViewModel, IViewData } from 'src/app/share/entities/view-model';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';

@Component({
  selector: 'app-aff-rate-issue',
  templateUrl: './aff-rate-issue.component.html',
  styleUrls: ['./aff-rate-issue.component.scss']
})
export class AffRateIssueComponent implements OnInit {
  
  constructor(private commonService: CommonService, private authService: AuthService) { }

  vm$: Observable<any>

  private cmd$ = new BehaviorSubject<IAffRateIssueCommand>({ load: true });
  currentPage: string = '';
  commingSoon: boolean = false;

  ngOnInit(): void {
    this.currentPage = '';
    this.commingSoon = false;
    this.loadPage$();
  }


  loadPage$() {
    this.vm$ = this.cmd$.pipe(
      switchMap(cmd => {
        if (cmd.load) {
          return this.commonService.getData('PageCommand', 'aff.rate.issues', 'page-load').pipe(
            map((v: IViewModelAffRateIssue) => {
              if (v.workingText)
                return { ...v };

              const ret = { ...v, actionsAllowed: true };
              
              if (ret.data) {
                // stat panel 
                ret.statPanelVm = ret.data.statPanel ? {
                  data: ret.data.statPanel
                } : null;

              }
              //console.log(ret);
              return ret;
            })
          );
        } else {
          
          return merge(

            // prep
            of(cmd).pipe(
              map(cmd => {
                const ret = { ...cmd.viewModel, actionsAllowed: false };
                return ret;
              })
            ),

            // invoke API
            of(cmd).pipe(

              // invoke server comand
              switchMap((cmd) => {

                if (cmd.invokeViewData)
                  return this.executeAction$(cmd);
                else
                  throw 'unknown command';
              })
            )
          );
        }
      })
    );
  }

  private executeAction$(cmd: IAffRateIssueCommand): Observable<IViewModelAffRateIssue> { 
    return this.commonService.getData('PageCommand', 'aff.rate.issues', cmd.actionName).pipe(
      map((v: IViewModelAffRateIssue) => {
        if (v.workingText)
          return { ...v };

        const ret = { ...v, actionsAllowed: true };
        
        if (ret.data) {
          ret.statPanelVm = ret.data.statPanel ? {
            data: ret.data.statPanel
          } : null;
        }
        
        return ret;
      })
    );
  }

  showData(vm: IViewModelAffRateIssue, action: string) {
    
    vm.affRateIssuePanelVm = null;
    this.currentPage = action;
    this.commingSoon = true;
    switch(action) {
      case 'no-pay-rule':
        this.commingSoon = false;
        vm.affRateIssuePanelVm = vm.data.missingPayRulePanel && !vm.data.missingPayRulePanel.unauthorized ? {
          data: vm.data.missingPayRulePanel,
          rows: vm.data.missingPayRulePanel.rows.map(r => ({ code: r[0], fields: r })),
          rowsFiltered: vm.data.missingPayRulePanel.rows.map(r => ({ code: r[0], fields: r })),
          instructions: vm.data.missingPayRulePanel.instructions ? vm.data.missingPayRulePanel.instructions : undefined,
          isEnable: false
        } : null;
        break;
      case 'no-vehicle-in-workflow':
        this.commingSoon = false;
        vm.affRateIssuePanelVm = vm.data.missingVehiclesInWorkflowPanel && !vm.data.missingVehiclesInWorkflowPanel.unauthorized ? {
          data: vm.data.missingVehiclesInWorkflowPanel,
          rows: vm.data.missingVehiclesInWorkflowPanel.rows.map(r => ({ code: r[0], fields: r })),
          rowsFiltered: vm.data.missingVehiclesInWorkflowPanel.rows.map(r => ({ code: r[0], fields: r })),
          instructions: vm.data.missingVehiclesInWorkflowPanel.instructions ? vm.data.missingHourlyRatePanel.instructions : undefined,
          isEnable: false
        } : null;
        break;
      case 'no-vehicle-in-payrule':
        this.commingSoon = false;
        vm.affRateIssuePanelVm = vm.data.vehiclesNotInPayrulePanel && !vm.data.vehiclesNotInPayrulePanel.unauthorized ? {
          data: vm.data.vehiclesNotInPayrulePanel,
          rows: vm.data.vehiclesNotInPayrulePanel.rows.map(r => ({ code: r[0], fields: r })),
          rowsFiltered: vm.data.vehiclesNotInPayrulePanel.rows.map(r => ({ code: r[0], fields: r })),
          instructions: vm.data.vehiclesNotInPayrulePanel.instructions ? vm.data.vehiclesNotInPayrulePanel.instructions : undefined,
          isEnable: false
        } : null;
        break;
      case 'no-hourly-rate':
        this.commingSoon = false;
        vm.affRateIssuePanelVm = vm.data.missingHourlyRatePanel && !vm.data.missingHourlyRatePanel.unauthorized ? {
          data: vm.data.missingHourlyRatePanel,
          rows: vm.data.missingHourlyRatePanel.rows.map(r => ({ code: r[0], fields: r })),
          rowsFiltered: vm.data.missingHourlyRatePanel.rows.map(r => ({ code: r[0], fields: r })),
          instructions: vm.data.missingHourlyRatePanel.instructions ? vm.data.missingHourlyRatePanel.instructions : undefined,
          isEnable: false
        } : null;
        break;
      case 'no-transfer-rate':
        break;
      case 'no-hourly-cost':
        break;
      case 'no-transfer-cost':
        break;
      case 'no-minimum-min':
        break;
      case 'no-cancel-min':
        break;
    }
  }

  /**
   * 
   */
   refreshPage() {
    this.cmd$.next({ load: true });
    this.authService.userInRole;
  }
}

/**
 * 
 */
 interface IViewModelAffRateIssue extends IPageDataViewModel {
  data?: { 
    statPanel: any,
    missingPayRulePanel: IViewData,
    missingVehiclesInWorkflowPanel: IViewData,
    vehiclesNotInPayrulePanel: IViewData,
    missingHourlyRatePanel: IViewData,
    missingTransferRatePanel: IViewData,
    missingHourlyCostPanel: IViewData,
    missingTransferCostPanel: IViewData,
    missingMinimumHoursPanel: IViewData,
    missingCancelMinutesPanel: IViewData,
  }

  statPanelVm: IStatViewModel;
  affRateIssuePanelVm: IDataPanelViewModel;

  actionsAllowed?: boolean;
}

/**

interface IAffRateIssueViewData {
  unauthorized: boolean;
  title: string;
  instructions: string;
  data: IAffRateIssuesData[];
}


 interface IAffRateIssueViewModel {
  origData: IAffRateIssueViewData;
  unauthorized: boolean;
  title: string;
  instructions: string;
  data: IAffRateIssuesData[];
  dataFiltered: IAffRateIssuesData[];
}


interface IAffRateIssuesData {
  workFlowCode: string;
  serviceAreaCode: string;
  affiliateCode: string;
  affiliateName: string;
  affiliateType: string;
  affiliatePayRuleCode: string;
  allocationRanking: string;
  vehicleTypeCode: string;
  vehicleTypeName: string;
  chargeHourlyRate: number;
  costHourlyRate: number;
  minimumHoursInMinutes: number;
  minimumCancellationMinutes: number;
  transferRateCount: number;
  transferRateCostCount: number;
  isAffiliatePayRuleSet: number;
  isVehicleSetInWorkFlow: number;
  isHourlyRateSet: number;
  isHourlyCostRateSet: number;
  isMinimumHoursInMinutesSet: number;
  isMinimumCancellationMinutesSet: number;
  isTransferRateSet: number;
  isTransferRateCostSet: number;
}
*/

/**
 * 
 */
 interface IAffRateIssueCommand {
  load?: boolean;

  actionName?: string;

  invokeViewData?: { };

  viewModel?: IViewModelAffRateIssue;
}
